<a href="javascript:;" (click)="close()" class="close-btn"><i class="far fa-times"></i></a>
<div class="modal-body bg-none d-flex flex-column align-items-center m-0 px-5 py-4 gap-3 text-center">
  <img src="/assets/images/rategenie.png" alt="" style="width: 15rem" />
  <h5 class="mb-0" i18n>Boost your revenue with smart pricing</h5>
  <p class="mb-0" i18n>
    Let RateGenie’s AI automatically adjust your rates based on demand, seasonality, and competition — so your listings
    stay booked and profitable.
  </p>
  <div class="d-flex gap-3 my-5">
    <a class="btn btn-secondary" (click)="onConnect()">
      <ng-container i18n>Start my free trial</ng-container> <i class="cs-icon cs-icon-arrow-right-long text-sm"></i>
    </a>
    <a class="btn btn-outline-light" href="https://rategenie.io/" target="_blank">
      <ng-container i18n>Learn more about RateGenie</ng-container>
    </a>
  </div>
</div>
